import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initPwa } from './lib/pwa';
import './styles/globals.css';

// Register the service worker + capture the install prompt as early as
// possible (before auth, before routing). Main app entry only — never booking.
initPwa();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
